import { Component, OnInit, Signal, signal } from '@angular/core';
import { BreadcrumbsComponent } from '../../../common/breadcrumbs/breadcrumbs.component';
import { ContentComponent } from '../../../components/content/content.component';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { CommonModule } from '@angular/common';
import { AlertComponent } from '../../../common/alert/alert.component';
import { FilterDataPipe } from '../../../pipes/filter-data.pipe';
import { Store } from '@ngrx/store';
import { selectApplicationList, selectLoading, selectPending } from '../../../store/selectors/application.selectors';
import { loadApplicationList } from '../../../store/actions/application.actions';
import { LabelComponent } from '../../../common/label/label.component';
import { SpinnerComponent } from '../../../common/spinner/spinner.component';
import { ApplicationListItem } from '../../../services/application.common.model';

@Component({
  selector: 'app-saved-list-page',
  standalone: true,
  imports: [
    CommonModule,
    AlertComponent,
    ContentComponent,
    BreadcrumbsComponent,
    FilterDataPipe,
    FormsModule,
    RouterModule,
    LabelComponent,
    SpinnerComponent
  ],
  templateUrl: './saved-list-page.component.html'
})
export class SavedListPageComponent implements OnInit {

  public filterValue: string = '';

  public applications: Signal<ApplicationListItem[]> = this.store$.selectSignal(selectApplicationList);

  public pending: Signal<boolean> = this.store$.selectSignal(selectPending);

  public loading: Signal<boolean> = this.store$.selectSignal(selectLoading);

  constructor(private store$: Store) {
  }

  public ngOnInit(): void {
    this.store$.dispatch(loadApplicationList({ code: 'roboczy' }));
  }
}
